import type { FilterValue } from '@pages/VendorsSearch/containers/FilterPills/atoms';
import {
	filterConfigsSidebarAtom,
	selectedSidebarFiltersAtom,
} from '@pages/VendorsSearch/containers/FilterPills/components/Sidebar/atoms';
import { useStartingPriceFilter } from '@pages/VendorsSearch/containers/FilterPills/components/StartingPriceFilter/use-starting-price-filter';
import { useUpdateFilterValues } from '@pages/VendorsSearch/containers/FilterPills/hooks/use-update-filter-values';
import { useAtomValue } from 'jotai';
import { useCallback } from 'react';

export const useSaveSidebarSelections = () => {
	const { updateFilterValues } = useUpdateFilterValues();
	const { filterValue: pricingFilterValue } = useStartingPriceFilter();
	const filterConfigsSidebar = useAtomValue(filterConfigsSidebarAtom);
	const selectedSidebarFilters = useAtomValue(selectedSidebarFiltersAtom);

	return useCallback(() => {
		const newFilterValues = filterConfigsSidebar.reduce((acc, filterConfig) => {
			const { id, filterOptions, type } = filterConfig;
			let value: FilterValue['value'] | null = null;

			switch (type) {
				case 'pricing':
					value = pricingFilterValue;
					break;
				case 'facet-single-select': {
					const option = filterOptions.find((option) =>
						selectedSidebarFilters.includes(option.id),
					);
					value = option ? { facetId: option.id } : null;
					break;
				}
				case 'facet-multi-select': {
					const options = filterOptions
						.filter((option) => selectedSidebarFilters.includes(option.id))
						.map((option) => ({
							facetId: option.id,
						}));
					value = options.length > 0 ? options : null;
					break;
				}
				default:
					break;
			}
			acc.push({ id, value });
			return acc;
		}, [] as FilterValue[]);
		updateFilterValues(newFilterValues);
	}, [
		filterConfigsSidebar,
		selectedSidebarFilters,
		updateFilterValues,
		pricingFilterValue,
	]);
};
